<div class="container-fluid" [hidden]="isAddDocument || isViewMode">
    <app-pagetitle [title]="'Templates'" [actionButton]="{
    label: '+ Add Template',
    onClick: addTemplate
  }">
    </app-pagetitle>

    <div class="page-content-wrapper">

        <app-loader [loading]="loading"></app-loader>

        <div [class.loading-content]="loading">

            <div class="row g-3">
                @if(successMessage){
                <div class="alert alert-success alert-dismissible fade show" role="alert">
                    {{ successMessage }}
                    <button type="button" class="btn-close" (click)="successMessage = ''"></button>
                </div>
                }
                <!-- @if(loading){
                <div class="text-center fw-bold">Loading data...</div>
                } -->
                @if(error){
                <div class="alert alert-danger" role="alert">{{ error }}</div>
                }
                @for(template of templates; track template;) {
                <div class="col-lg-4 col-md-6 col-sm-12">
                    <div class="card d-flex flex-column">
                        <div class="card-body">
                            <div class="row align-items-center mb-2">
                                <div class="col-6">
                                    <img src="assets/icons/icons8-clipboard-100.png" alt="clipboard"
                                        style="width:40px;">
                                </div>

                                <div class="col-6 text-end">
                                    <i class="mdi mdi-pencil fs-4 me-2  " style="cursor:pointer;" title="Edit"
                                        (click)="templateAction(template, 'edit')"></i>
                                    <i class="mdi mdi-eye fs-4 me-2" style="cursor:pointer;" title="View"
                                        (click)="templateAction(template, 'view')"></i>
                                    <i class="mdi mdi-download fs-4 me-2" style="cursor:pointer;" title="Download"
                                        (click)="templateAction(template, 'download')">
                                    </i>
                                    <i class="mdi mdi-delete fs-4" style="cursor:pointer;" title="Delete"
                                        (click)="templateAction(template, 'delete')">
                                    </i>
                                </div>
                            </div>

                            <div class="d-flex flex-column mb-3">
                                <div class="d-flex align-items-center justify-content-between">
                                    <div class="d-flex align-items-center gap-2">

                                        <div class="fs-5 fw-semibold">
                                            {{ template?.name }}
                                        </div>
                                    </div>

                                </div>
                                <small class="text-muted">
                                    {{ template?.description || ''}}
                                </small>
                            </div>
                            <div class="row mb-3">
                                <div class="col-6">
                                    <p class="card-text">{{template.category}}</p>
                                </div>
                                <div class="col-6 text-end">
                                    Signers: {{ template.allSignersPositions?.length || 0 }}
                                </div>
                            </div>


                            <div class="d-flex align-items-center justify-content-between mb-3 p-2 bg-light rounded">

                                <small class="text-muted text-truncate me-2">
                                    Template ID: {{ template._id }}
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
                }

                @if(!loading && templates.length == 0){
                <div class="text-center fw-bold">No templates available.</div>
                }

            </div>

        </div>
    </div>
</div>

@if(isAddDocument){
<app-add-template (back)="back($event)" [template]="selectedTemplate"></app-add-template>
}

@if(isViewMode){
<app-view-pdf [documentData]="documentData" (close)="backView()"></app-view-pdf>
}